export let API_SERVICE_BASE_PATH = '';

export function setApiBasePath(basePath: string): void {
  API_SERVICE_BASE_PATH = basePath;
}
